exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-module=Twitter] ul.twitter-container{margin-top:20px;display:flex;flex-direction:column;flex-wrap:wrap;justify-content:space-between}[data-module=Twitter] .twitter-header{padding-top:40px;border-top:3px solid #eceff1;display:flex}[data-module=Twitter] .twitter-header h4{display:inline-block;line-height:30px;vertical-align:middle;padding:0;margin:0}[data-module=Twitter] .twitter-header .mysvg{width:30px;height:30px;display:inline-block;margin-left:10px;vertical-align:middle}[data-module=Twitter] .twitter-header .mysvg svg{width:100%;height:100%}[data-module=Twitter] .twitter-header .mysvg svg .icon-background{width:30px;height:30px}[data-module=Twitter] .twitter-header .mysvg svg .icon-symbol{fill:#fff}[data-module=Twitter] .twitter-header .mysvg svg.twitter-icon .icon-background{fill:#78c2f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./medscape_modules/twitter-widget/styles.scss
// module id = 639
// module chunks = 0